import React from 'react';
import { useCart } from '../context/CartContext';
import { ShoppingCartIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export function CartBadge() {
  const {
    cartItemCount,
    cartTotal,
    toggleCart
  } = useCart();
  const {
    t,
    formatPriceInline
  } = useLanguage();
  if (cartItemCount === 0) return null;
  return <AnimatePresence data-id="element-717">
      <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-6 left-0 right-0 z-40 px-4 flex justify-center pointer-events-none" data-id="element-718">
        <div className="w-full max-w-md pointer-events-auto" data-id="element-719">
          <button onClick={toggleCart} className="w-full bg-terracota text-white rounded-full p-4 shadow-xl shadow-black/50 flex items-center justify-between active:scale-95 transition-transform border border-white/10" data-id="element-720">
            <div className="flex items-center gap-3" data-id="element-721">
              <div className="relative" data-id="element-722">
                <ShoppingCartIcon className="w-6 h-6" data-id="element-723" />
                <span className="absolute -top-2 -right-2 bg-naranja text-white text-xs font-bold w-5 h-5 rounded-full flex items-center justify-center shadow-sm" data-id="element-724">
                  {cartItemCount}
                </span>
              </div>
              <span className="font-medium" data-id="element-725">{t('viewOrder')}</span>
            </div>
            <span className="font-bold text-sm" data-id="element-726">
              {formatPriceInline(cartTotal)}
            </span>
          </button>
        </div>
      </motion.div>
    </AnimatePresence>;
}